import { useState, useEffect } from 'react';
import { Breakpoints } from '../styled/constants';

const useScreenSize = () => {
  const [width, setWidth] = useState(0);

  const PashaLinkSmallDesktop = width >= Breakpoints.PashaSmallDesktop;
  const PashaLinkLargeDesktop = width >= Breakpoints.PashaCustomDesktop;
  const PashaLinkCustomDesktop =
    width >= Breakpoints.PashaSmallDesktop &&
    width < Breakpoints.PashaCustomDesktop;
  const isLarge = width >= Breakpoints.desktop;
  const isMedium = width >= Breakpoints.tablet && width < Breakpoints.desktop;
  const isSmallDesktop =
    width >= Breakpoints.smallDesktop && width < Breakpoints.desktop;
  const isTablet =
    width >= Breakpoints.tablet && width < Breakpoints.smallDesktop;
  const isSmall = width < Breakpoints.tablet;
  const isSmallOrLargeDesktop = isSmallDesktop || isLarge;

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    PashaLinkSmallDesktop,
    PashaLinkLargeDesktop,
    PashaLinkCustomDesktop,
    isLarge,
    isMedium,
    isSmall,
    isTablet,
    isSmallDesktop,
    isSmallOrLargeDesktop
  };
};

export default useScreenSize;
